// // OrderTracker.js - UI closely matching SalesTracker
// import React, { useState, useEffect } from "react";
// import {
//   Container, Box, Card, CardContent, Grid, Typography, TextField,
//   FormControl, InputLabel, Select, MenuItem, Button, TableContainer,
//   Table, TableHead, TableRow, TableCell, TableBody, Chip, IconButton,
//   Tooltip, Dialog, DialogTitle, DialogContent, DialogActions,
//   Stepper, Step, StepLabel, LinearProgress, InputAdornment
// } from "@mui/material";
// import { ThemeProvider, createTheme, alpha } from "@mui/material/styles";
// import {
//   AddRounded, EditRounded, DeleteRounded, SearchRounded, FileDownloadRounded,
//   AssessmentRounded, PendingActionsRounded, LoopRounded, TaskAltRounded,
//   LocalShippingRounded, PaymentsRounded, GroupRounded, RefreshRounded
// } from "@mui/icons-material";
// import { motion, AnimatePresence } from "framer-motion";
// import { orderAPI } from "../services/api";
// import { useAuth } from "../context/AuthContext";

// const getTheme = () => createTheme({
//   palette: {
//     mode: "light",
//     primary: { main: "#005b82", light: "#2586bc", dark: "#003d5c" },
//     background: { default: "#f8fafc", paper: "#fff" }
//   },
//   shape: { borderRadius: 12 }
// });

// const STATUS_OPTS = [
//   { value: "quoted", label: "Quoted" },
//   { value: "ordered", label: "Ordered" },
//   { value: "in_production", label: "In Production" },
//   { value: "ready_for_shipment", label: "Ready for Shipment" },
//   { value: "shipped", label: "Shipped" },
//   { value: "delivered", label: "Delivered" },
//   { value: "cancelled", label: "Cancelled" },
// ];

// const OrderTracker = () => {
//   const { user } = useAuth();
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [alert, setAlert] = useState({ open:false, message:"", severity:"success" });

//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");

//   const [open, setOpen] = useState(false);
//   const [activeStep, setActiveStep] = useState(0);
//   const [editing, setEditing] = useState(null);
//   const [form, setForm] = useState({
//     sr_no: "", vessel_name: "", rfq_number: "", po_number: "",
//     commited_delivery_date: "", current_status: "quoted", status_remarks: "",
//     assigned_to: "", priority: "medium"
//   });

//   const perms = {
//     canCreate: () => ["SALES", "SUPERADMIN"].includes(user?.role_name),
//     canEditAll: () => user?.is_superuser || user?.role_name === "SUPERADMIN",
//     canEditSales: () => ["SALES", "SUPERADMIN"].includes(user?.role_name),
//     canViewOnly: () => ["ACCOUNTS"].includes(user?.role_name)
//   };

//   useEffect(() => { fetchOrders(); }, []);

//   const fetchOrders = async () => {
//     try {
//       setLoading(true);
//       const res = await orderAPI.getOrders();
//       setOrders(res.data || []);
//     } catch (e) {
//       console.error(e);
//     } finally { setLoading(false); }
//   };

//   const showAlert = (msg, severity="success") => {
//     setAlert({ open:true, message:msg, severity });
//     setTimeout(()=> setAlert({ open:false, message:"", severity:"success" }), 3200);
//   };

//   const fmtDate = (d) => d ? new Date(d).toLocaleDateString() : "-";

//   const filtered = orders.filter(o => {
//     const q = searchTerm.toLowerCase();
//     const matchQ = (o.vessel_name || "").toLowerCase().includes(q) ||
//                    (o.sr_no || "").toLowerCase().includes(q) ||
//                    (o.po_number || "").toLowerCase().includes(q);
//     const matchStatus = statusFilter === "all" || o.current_status === statusFilter;
//     return matchQ && matchStatus;
//   });

//   const openModal = (order=null) => {
//     if (!order && !perms.canCreate()) return showAlert("No permission", "error");
//     setEditing(order);
//     setForm(order || {
//       sr_no: order?.sr_no ?? "", vessel_name: "", rfq_number: "", po_number: "",
//       commited_delivery_date: "", current_status: "quoted", status_remarks: "",
//       assigned_to: "", priority: "medium"
//     });
//     setActiveStep(0);
//     setOpen(true);
//   };
//   const closeModal = () => { setOpen(false); setEditing(null); }

//   const onChange = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

//   const onSubmit = async () => {
//     if (!form.sr_no || !form.vessel_name) return showAlert("SR No & Vessel required", "error");
//     try {
//       if (editing) await orderAPI.updateOrder(editing.id, form);
//       else await orderAPI.createOrder(form);
//       showAlert(editing ? "Updated" : "Created");
//       await fetchOrders();
//       closeModal();
//     } catch (e) {
//       console.error(e);
//       showAlert("Save error", "error");
//     }
//   };

//   const onDelete = async (id) => {
//     if (!perms.canEditAll()) return showAlert("No permission", "error");
//     if (!window.confirm("Delete this record?")) return;
//     try {
//       await orderAPI.deleteOrder(id);
//       showAlert("Deleted");
//       await fetchOrders();
//     } catch {
//       showAlert("Delete failed", "error");
//     }
//   };

//   const exportExcel = async () => {
//     try {
//       const res = await orderAPI.exportExcel();
//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const a = document.createElement("a");
//       a.href = url; a.setAttribute("download", "order_export.xlsx");
//       document.body.appendChild(a); a.click(); a.remove();
//       showAlert("Exported");
//     } catch {
//       showAlert("Export failed", "error");
//     }
//   };

//   return (
//     <ThemeProvider theme={getTheme()}>
//       <Box sx={{ minHeight: "100vh", background: "linear-gradient(135deg,#f8fafc 0%,#e2e8f0 100%)", pb:4 }}>
//         <Container maxWidth="xl" sx={{ py:2 }}>
//           {alert.open && <Box sx={{ mb:2 }}><Card variant="outlined"><CardContent><Typography>{alert.message}</Typography></CardContent></Card></Box>}

//           {/* Header / Stats */}
//           <Grid container spacing={4} sx={{ mb:3 }}>
//             {[
//               { key: "total", label: "Total Orders", icon: <AssessmentRounded/>, color: "#005b82" },
//               { key: "quoted", label: "Quoted", icon: <PendingActionsRounded/>, color: "#ff9800" },
//               { key: "ordered", label: "Ordered", icon: <LoopRounded/>, color: "#2196f3" },
//               { key: "shipped", label: "Shipped", icon: <LocalShippingRounded/>, color: "#4caf50" },
//               { key: "delivered", label: "Delivered", icon: <TaskAltRounded/>, color: "#4caf50" },
//             ].map(({key,label,icon,color}) => {
//               const count = key === "total" ? orders.length : orders.filter(o => o.current_status===key).length;
//               const pct = orders.length ? (count / orders.length) * 100 : 0;
//               return (
//                 <Grid item xs={12} sm={6} md={2.4} key={key}>
//                   <Card><CardContent>
//                     <Box sx={{ display:"flex", justifyContent:"space-between", mb:1 }}>
//                       <Box sx={{ p:1, borderRadius:2, background: alpha(color,0.1), color }}>{icon}</Box>
//                       <Typography variant="h4" fontWeight={700} color={color}>{count}</Typography>
//                     </Box>
//                     <Typography variant="body2" color="text.secondary">{label}</Typography>
//                     <LinearProgress variant="determinate" value={pct} sx={{ height:6, borderRadius:3, mt:1, backgroundColor: alpha(color,0.2), "& .MuiLinearProgress-bar": { backgroundColor: color } }} />
//                     <Typography variant="caption" color="text.secondary">{pct.toFixed(1)}% of total</Typography>
//                   </CardContent></Card>
//                 </Grid>
//               );
//             })}
//           </Grid>

//           {/* Controls */}
//           <Card sx={{ mb:3 }}>
//             <CardContent>
//               <Box sx={{ display:"flex", gap:2, alignItems:"center", flexWrap:"wrap" }}>
//                 <TextField size="small" placeholder="Search..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)}
//                   InputProps={{ startAdornment: (<InputAdornment position="start"><SearchRounded/></InputAdornment>) }} sx={{ minWidth:280, flex:1 }} />
//                 <FormControl size="small" sx={{ minWidth:140 }}>
//                   <InputLabel>Status</InputLabel>
//                   <Select value={statusFilter} label="Status" onChange={(e)=>setStatusFilter(e.target.value)}>
//                     <MenuItem value="all">All Status</MenuItem>
//                     {STATUS_OPTS.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
//                   </Select>
//                 </FormControl>
//                 <Box sx={{ ml:"auto", display:"flex", gap:1 }}>
//                   <Button variant="outlined" startIcon={<FileDownloadRounded/>} onClick={exportExcel}>Export</Button>
//                   {perms.canCreate() && <Button variant="contained" startIcon={<AddRounded/>} onClick={()=>openModal()}>New Order</Button>}
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>

//           {/* Table */}
//           <Card>
//             <CardContent sx={{ p:0 }}>
//               {loading ? (
//                 <Box sx={{ p:4, textAlign:"center" }}><LinearProgress sx={{ mb:2 }} /><Typography>Loading orders…</Typography></Box>
//               ) : (
//                 <TableContainer sx={{ maxHeight: 600 }}>
//                   <Table stickyHeader>
//                     <TableHead>
//                       <TableRow>
//                         <TableCell sx={{ fontWeight:700 }}>SR</TableCell>
//                         <TableCell sx={{ fontWeight:700 }}>Vessel</TableCell>
//                         <TableCell sx={{ fontWeight:700 }}>RFQ</TableCell>
//                         <TableCell sx={{ fontWeight:700 }}>PO</TableCell>
//                         <TableCell sx={{ fontWeight:700 }}>Delivery Date</TableCell>
//                         <TableCell sx={{ fontWeight:700 }}>Status</TableCell>
//                         <TableCell sx={{ fontWeight:700 }}>Remarks</TableCell>
//                         {/* <TableCell sx={{ fontWeight:700 }}>Assigned</TableCell> */}
//                         <TableCell sx={{ fontWeight:700 }}>Priority</TableCell>
//                         <TableCell align="center" sx={{ fontWeight:700 }}>Actions</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {filtered.map(o => (
//                         <TableRow key={o.id} hover>
//                           <TableCell><Typography fontWeight={600}>{o.sr_no}</Typography></TableCell>
//                           <TableCell>{o.vessel_name}</TableCell>
//                           <TableCell>{o.rfq_number || "-"}</TableCell>
//                           <TableCell>{o.po_number || "-"}</TableCell>
//                           <TableCell>{fmtDate(o.commited_delivery_date)}</TableCell>
//                           <TableCell><Chip label={o.current_status} size="small" /></TableCell>
//                           <TableCell>{o.status_remarks || "-"}</TableCell>
//                           {/* <TableCell>{o.assigned_to_name || "-"}</TableCell> */}
//                           <TableCell>{o.priority}</TableCell>
//                           <TableCell align="center">
//                             <Box sx={{ display:"flex", gap:1, justifyContent:"center" }}>
//                               <Tooltip title="Edit">
//                                 <IconButton size="small" onClick={()=>openModal(o)}><EditRounded fontSize="small"/></IconButton>
//                               </Tooltip>
//                               {perms.canEditAll() && (
//                                 <Tooltip title="Delete">
//                                   <IconButton size="small" onClick={()=>onDelete(o.id)} color="error"><DeleteRounded fontSize="small"/></IconButton>
//                                 </Tooltip>
//                               )}
//                             </Box>
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               )}

//               {!loading && filtered.length === 0 && (
//                 <Box sx={{ p:4, textAlign:"center" }}>
//                   <AssessmentRounded sx={{ fontSize:48, color:"text.secondary", mb:2 }} />
//                   <Typography variant="h6" color="text.secondary">No orders found</Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Card>

//           {/* Modal */}
//           <AnimatePresence>
//             {open && (
//               <Dialog open onClose={closeModal} maxWidth="lg" fullWidth>
//                 <DialogTitle sx={{ background: "linear-gradient(135deg,#005b82 0%,#2586bc 100%)", color:"white" }}>
//                   <Box sx={{ display:"flex", alignItems:"center", gap:1 }}>
//                     <PaymentsRounded /><Typography variant="h6">{editing ? "Edit Order" : "Create Order"}</Typography>
//                   </Box>
//                 </DialogTitle>
//                 <Box sx={{ px:2, pt:2 }}>
//                   <Stepper activeStep={activeStep} alternativeLabel>
//                     {["Order Details","Status","Additional"].map(l => <Step key={l}><StepLabel>{l}</StepLabel></Step>)}
//                   </Stepper>
//                 </Box>
//                 <DialogContent>
//                   {activeStep === 0 && (
//                     <Box sx={{ mt:2, display:"grid", gap:2 }}>
//                       <Box sx={{ display:"flex", gap:2 }}>
//                         <TextField name="sr_no" label="SR No *" value={form.sr_no} onChange={onChange} fullWidth 
//                         InputLabelProps={{ sx: { fontWeight: 'bold' } }}
//                         />
//                         <TextField name="vessel_name" label="Vessel Name *" value={form.vessel_name} onChange={onChange} fullWidth 
//                         InputLabelProps={{ sx: { fontWeight: 'bold' } }}
//                         />
//                       </Box>
//                       <Box sx={{ display:"flex", gap:2 }}>
//                         <TextField name="rfq_number" label="RFQ Number" value={form.rfq_number} onChange={onChange} fullWidth                               InputLabelProps={{
//     sx: { fontWeight: 'bold' }   // <-- Make label bold
//   }} />
//                         <TextField name="po_number" label="PO Number" value={form.po_number} onChange={onChange} fullWidth                               InputLabelProps={{
//     sx: { fontWeight: 'bold' }   // <-- Make label bold
//   }} />
//                       </Box>
//                       <TextField name="commited_delivery_date" label="Committed Delivery Date" type="date" value={form.commited_delivery_date || ""} onChange={onChange} fullWidth InputLabelProps={{ shrink:true, sx: { fontWeight: 'bold' } }} />
//                     </Box>
//                   )}

//                   {activeStep === 1 && (
//                     <Box sx={{ mt:2, display:"grid", gap:2 }}>
//                       <FormControl fullWidth>
//                         <InputLabel sx={{ fontWeight: 'bold' }}>Status</InputLabel>
//                         <Select name="current_status" value={form.current_status} label="Status" onChange={onChange}>
//                           {STATUS_OPTS.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
//                         </Select>
//                       </FormControl>
//                       <TextField name="status_remarks" label="Status Remarks" value={form.status_remarks} onChange={onChange} fullWidth multiline 
//                       // rows={3} 
//                       InputLabelProps={{ sx: { fontWeight: 'bold' } }} 
//                       />
//                     </Box>
//                   )}

//                   {activeStep === 2 && (
//                     <Box sx={{ mt:2, display:"grid", gap:2 }}>
//                       {/* <TextField name="assigned_to" label="Assigned To (user id)" value={form.assigned_to || ""} onChange={onChange} fullWidth /> */}
//                       <FormControl fullWidth>
//                         <InputLabel sx={{ fontWeight: 'bold' }}>Priority</InputLabel>
//                         <Select name="priority" value={form.priority} label="Priority" onChange={onChange}>
//                           <MenuItem value="low">Low</MenuItem>
//                           <MenuItem value="medium">Medium</MenuItem>
//                           <MenuItem value="high">High</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Box>
//                   )}
//                 </DialogContent>

//                 <DialogActions>
//                   <Button onClick={closeModal}>Cancel</Button>
//                   <Box sx={{ flex:1 }} />
//                   <Button disabled={activeStep===0} onClick={()=>setActiveStep(s=>s-1)} variant="outlined">Back</Button>
//                   {activeStep < 2 ? (
//                     <Button variant="contained" onClick={()=>setActiveStep(s=>s+1)}>Next</Button>
//                   ) : (
//                     <Button variant="contained" onClick={onSubmit}>{editing ? "Update Order":"Create Order"}</Button>
//                   )}
//                 </DialogActions>
//               </Dialog>
//             )}
//           </AnimatePresence>
//         </Container>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default OrderTracker;
// OrderTracker_redesign_like_SalesTracker.js
import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  LinearProgress,
  InputAdornment,
  Snackbar,
  Alert as MuiAlert,
} from "@mui/material";
import { ThemeProvider, createTheme, alpha } from "@mui/material/styles";
import {
  AddRounded,
  EditRounded,
  DeleteRounded,
  SearchRounded,
  FileDownloadRounded,
  LocalShippingRounded,
  TaskAltRounded,
  PendingActionsRounded,
  LoopRounded,
  AssessmentRounded,
  RefreshRounded,
  AssignmentTurnedInRounded,
} from "@mui/icons-material";
import { AnimatePresence } from "framer-motion";
import { orderAPI, userAPI } from "../services/api";
import { useAuth } from "../context/AuthContext";

// Theme (same look as SalesTracker)
const getTheme = () =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: "#005b82", light: "#2586bc", dark: "#003d5c" },
      background: { default: "#f8fafc", paper: "#ffffff" },
    },
    shape: { borderRadius: 12 },
  });

// Status + Priority options based on your model
const STATUS_OPTS = [
  { value: "quoted", label: "Quoted" },
  { value: "ordered", label: "Ordered" },
  { value: "in_production", label: "In Progress" },
  { value: "ready_for_shipment", label: "Ready for Shipment" },
  { value: "shipped", label: "Shipped" },
  { value: "delivered", label: "Delivered" },
  { value: "cancelled", label: "Cancelled" },
];

const PRIORITY_OPTS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

const OrderTracker = () => {
  const { canCreateModule, canUpdateModule, canDeleteModule } = useAuth();

  const [orders, setOrders] = useState([]);
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);

  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [priorityFilter, setPriorityFilter] = useState("all");

  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [editingOrder, setEditingOrder] = useState(null);

  const emptyOrderForm = {
    sr_no: "",
    vessel_name: "",
    rfq_number: "",
    po_number: "",
    commited_delivery_date: "",
    current_status: "",
    status_remarks: "",
    priority: "",
    assigned_to: "", // will store user id
  };

  const [orderForm, setOrderForm] = useState(emptyOrderForm);

  // Permissions - driven by the live Permissions matrix for order_tracker.
  const perms = {
    canCreate: () => canCreateModule("order_tracker"),
    canEdit: () => canUpdateModule("order_tracker"),
    canDelete: () => canDeleteModule("order_tracker"),
  };

  // Helpers
  const showAlert = (message, severity = "success") => {
    setAlert({ open: true, message, severity });
    setTimeout(
      () => setAlert({ open: false, message: "", severity: "success" }),
      3200
    );
  };

  const fmtDate = (d) =>
    d ? new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "-";

  const statusLabel = (v) =>
    STATUS_OPTS.find((o) => o.value === v)?.label || v || "-";

  const priorityLabel = (v) =>
    PRIORITY_OPTS.find((o) => o.value === v)?.label || v || "-";

  // Initial load
  useEffect(() => {
    (async () => {
      await Promise.all([fetchOrders(), fetchStats(), fetchUsers()]);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await orderAPI.getOrders();
      setOrders(res.data || []);
    } catch (e) {
      console.error(e);
      showAlert("Error fetching orders", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await orderAPI.getStats();
      setStats(res.data || null);
    } catch (e) {
      console.error(e);
      // not critical
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await userAPI.getUsers();
      setUsers(res.data || []);
    } catch (e) {
      console.error(e);
      // ignore silently
    }
  };

  // Filtered data
  const filtered = orders.filter((o) => {
    const q = searchTerm.toLowerCase();
    const matchQ =
      (o.sr_no || "").toString().toLowerCase().includes(q) ||
      (o.vessel_name || "").toLowerCase().includes(q) ||
      (o.rfq_number || "").toLowerCase().includes(q) ||
      (o.po_number || "").toLowerCase().includes(q);

    const matchStatus =
      statusFilter === "all" || o.current_status === statusFilter;

    const matchPriority =
      priorityFilter === "all" || o.priority === priorityFilter;

    return matchQ && matchStatus && matchPriority;
  });

  // Open modal (create or edit)
  const openModal = async (order = null) => {
    if (!order && !perms.canCreate()) {
      return showAlert("You do not have permission to create orders", "error");
    }

    if (order) {
      // edit
      setEditingOrder(order);
      setOrderForm({
        sr_no: order.sr_no ?? "",
        vessel_name: order.vessel_name ?? "",
        rfq_number: order.rfq_number ?? "",
        po_number: order.po_number ?? "",
        commited_delivery_date: order.commited_delivery_date ?? "",
        current_status: order.current_status ?? "",
        status_remarks: order.status_remarks ?? "",
        priority: order.priority ?? "",
        assigned_to: order.assigned_to ?? "",
      });
    } else {
      // create → fetch next sr_no from backend
      try {
        const res = await orderAPI.getNextSrNo();
        const nextSr = res.data?.next_sr_no
          ? res.data.next_sr_no.toString()
          : "";
        setEditingOrder(null);
        setOrderForm({
          ...emptyOrderForm,
          sr_no: nextSr,
        });
      } catch (e) {
        console.error(e);
        // even if SR no not loaded, allow create; backend will handle
        setEditingOrder(null);
        setOrderForm(emptyOrderForm);
        showAlert("Unable to auto-generate SR No. You can still create.", "warning");
      }
    }

    setActiveStep(0);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setEditingOrder(null);
  };

  const onChange = (e) =>
    setOrderForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onSubmit = async () => {
    try {
      // No required fields in UI – send what we have
      const payload = { ...orderForm };

      // Convert empty date string to null
      if (payload.commited_delivery_date === "") {
        payload.commited_delivery_date = null;
      }

      // If assigned_to is empty string, send null
      if (payload.assigned_to === "") {
        payload.assigned_to = null;
      }

      if (editingOrder) {
        await orderAPI.updateOrder(editingOrder.id, payload);
      } else {
        await orderAPI.createOrder(payload);
      }

      showAlert(
        editingOrder ? "Order updated successfully" : "Order created successfully"
      );
      await Promise.all([fetchOrders(), fetchStats()]);
      closeModal();
    } catch (e) {
      console.error(e);
      if (e?.response?.data) {
        const data = e.response.data;
        const msg = Object.entries(data)
          .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : v}`)
          .join(" ");
        showAlert(msg, "error");
      } else {
        showAlert("Failed to save order", "error");
      }
    }
  };

  const onDelete = async (id) => {
    if (!perms.canDelete()) {
      return showAlert("You do not have permission to delete orders", "error");
    }
    if (!window.confirm("Delete this order?")) return;

    try {
      await orderAPI.deleteOrder(id);
      showAlert("Order deleted");
      await Promise.all([fetchOrders(), fetchStats()]);
    } catch (e) {
      console.error(e);
      showAlert("Failed to delete order", "error");
    }
  };

  const exportExcel = async () => {
    try {
      const res = await orderAPI.exportExcel();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", "order_tracker.xlsx");
      document.body.appendChild(a);
      a.click();
      a.remove();
      showAlert("Excel exported");
    } catch (e) {
      console.error(e);
      showAlert("Export failed", "error");
    }
  };

  // Stats cards
  const statusCount = (key) => {
    if (!stats) return 0;
    return stats[key] ?? 0;
  };

  const totalCount = stats?.total ?? orders.length;

  return (
    <ThemeProvider theme={getTheme()}>
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg,#f8fafc 0%,#e2e8f0 100%)",
          pb: 4,
        }}
      >
        <Snackbar
          open={alert.open}
          autoHideDuration={4000}
          onClose={() => setAlert((a) => ({ ...a, open: false }))}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={() => setAlert((a) => ({ ...a, open: false }))}
            severity={alert.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alert.message}
          </MuiAlert>
        </Snackbar>

        <Container maxWidth="xl" sx={{ py: 2 }}>

          {/* Stats */}
          <Grid container spacing={4} sx={{ mb: 3 }}>
            {[
              {
                key: "total",
                label: "Total Orders",
                icon: <AssignmentTurnedInRounded />,
                color: "#005b82",
                value: totalCount,
              },
              {
                key: "quoted",
                label: "Quoted",
                icon: <PendingActionsRounded />,
                color: "#9c27b0",
                value: statusCount("quoted"),
              },
              {
                key: "ordered",
                label: "Ordered",
                icon: <LoopRounded />,
                color: "#2196f3",
                value: statusCount("ordered"),
              },
              {
                key: "in_production",
                label: "In Progress",
                icon: <LoopRounded />,
                color: "#ff9800",
                value: statusCount("in_production"),
              },
              {
                key: "shipped",
                label: "Shipped",
                icon: <LocalShippingRounded />,
                color: "#3f51b5",
                value: statusCount("shipped"),
              },
              {
                key: "delivered",
                label: "Delivered",
                icon: <TaskAltRounded />,
                color: "#4caf50",
                value: statusCount("delivered"),
              },
              {
                key: "cancelled",
                label: "Cancelled",
                icon: <RefreshRounded />,
                color: "#f44336",
                value: statusCount("cancelled"),
              },
            ].map(({ key, label, icon, color, value }) => {
              const pct = totalCount ? (value / totalCount) * 100 : 0;
              return (
                <Grid item xs={12} sm={6} md={3} lg={2.4} key={key}>
                  <Card>
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <Box
                          sx={{
                            p: 1,
                            borderRadius: 2,
                            background: alpha(color, 0.1),
                            color,
                          }}
                        >
                          {icon}
                        </Box>
                        <Typography variant="h4" fontWeight={700} color={color}>
                          {value}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {label}
                      </Typography>
                      <LinearProgress
                        variant="determinate"
                        value={pct}
                        sx={{
                          height: 6,
                          borderRadius: 3,
                          mt: 1,
                          backgroundColor: alpha(color, 0.2),
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: color,
                          },
                        }}
                      />
                      <Typography variant="caption" color="text.secondary">
                        {pct.toFixed(1)}% of total
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          {/* Controls */}
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <TextField
                  size="small"
                  placeholder="Search orders..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchRounded />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ minWidth: 280, flex: 1 }}
                />

                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={statusFilter}
                    label="Status"
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Status</MenuItem>
                    {STATUS_OPTS.map((o) => (
                      <MenuItem key={o.value} value={o.value}>
                        {o.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>Priority</InputLabel>
                  <Select
                    value={priorityFilter}
                    label="Priority"
                    onChange={(e) => setPriorityFilter(e.target.value)}
                  >
                    <MenuItem value="all">All Priority</MenuItem>
                    {PRIORITY_OPTS.map((o) => (
                      <MenuItem key={o.value} value={o.value}>
                        {o.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    startIcon={<FileDownloadRounded />}
                    onClick={exportExcel}
                  >
                    Export
                  </Button>
                  {perms.canCreate() && (
                    <Button
                      variant="contained"
                      startIcon={<AddRounded />}
                      onClick={() => openModal()}
                      sx={{
                        background:
                          "linear-gradient(135deg,#005b82 0%,#2586bc 100%)",
                      }}
                    >
                      New Order
                    </Button>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Table */}
          <Card>
            <CardContent sx={{ p: 0 }}>
              {loading ? (
                <Box sx={{ p: 4, textAlign: "center" }}>
                  <LinearProgress sx={{ mb: 2 }} />
                  <Typography color="text.secondary">
                    Loading order data...
                  </Typography>
                </Box>
              ) : (
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700 }}>SR</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Vessel</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>RFQ</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>PO</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>
                          Delivery Date
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>
                          Priority
                        </TableCell>
                        {/* <TableCell sx={{ fontWeight: 700 }}>
                          Assigned To
                        </TableCell> */}
                        <TableCell align="center" sx={{ fontWeight: 700 }}>
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filtered.map((o) => (
                        <TableRow key={o.id} hover>
                          <TableCell>
                            <Typography fontWeight={600}>
                              {o.sr_no}
                            </Typography>
                          </TableCell>
                          <TableCell>{o.vessel_name || "-"}</TableCell>
                          <TableCell>{o.rfq_number || "-"}</TableCell>
                          <TableCell>{o.po_number || "-"}</TableCell>
                          <TableCell>
                            {fmtDate(o.commited_delivery_date)}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={statusLabel(o.current_status)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={priorityLabel(o.priority)}
                              size="small"
                              color={
                                o.priority === "high"
                                  ? "error"
                                  : o.priority === "medium"
                                  ? "warning"
                                  : "default"
                              }
                            />
                          </TableCell>
                          {/* <TableCell>{o.assigned_to_name || "-"}</TableCell> */}
                          <TableCell align="center">
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                justifyContent: "center",
                              }}
                            >
                              <Tooltip title="Edit">
                                <IconButton
                                  size="small"
                                  onClick={() => openModal(o)}
                                  disabled={!perms.canEdit()}
                                >
                                  <EditRounded fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              {perms.canDelete() && (
                                <Tooltip title="Delete">
                                  <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => onDelete(o.id)}
                                  >
                                    <DeleteRounded fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {!loading && filtered.length === 0 && (
                <Box sx={{ p: 4, textAlign: "center" }}>
                  <AssessmentRounded
                    sx={{ fontSize: 48, color: "text.secondary", mb: 2 }}
                  />
                  <Typography variant="h6" color="text.secondary">
                    No orders found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {searchTerm ||
                    statusFilter !== "all" ||
                    priorityFilter !== "all"
                      ? "Try adjusting your search or filter criteria"
                      : "Create your first order to get started"}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>

          {/* Modal */}
          <AnimatePresence>
            {open && (
              <Dialog open onClose={closeModal} maxWidth="md" fullWidth>
                <DialogTitle
                  sx={{
                    background:
                      "linear-gradient(135deg,#005b82 0%,#2586bc 100%)",
                    color: "white",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <AssignmentTurnedInRounded />
                    <Typography variant="h6">
                      {editingOrder ? "Edit Order" : "Create Order"}
                    </Typography>
                  </Box>
                </DialogTitle>

                <Box sx={{ px: 2, pt: 2 }}>
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {["Order Details", "Status & Assignment", "Additional Info"].map(
                      (label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      )
                    )}
                  </Stepper>
                </Box>

                <DialogContent>
                  {activeStep === 0 && (
                    <Box sx={{ mt: 2, display: "grid", gap: 2 }}>
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                          name="sr_no"
                          label="SR No"
                          value={orderForm.sr_no}
                          onChange={onChange}
                          fullWidth
                          disabled // SR No auto-generated, not editable
                          helperText="Auto-generated by system"
                        />
                        <TextField
                          name="vessel_name"
                          label="Vessel Name"
                          value={orderForm.vessel_name}
                          onChange={onChange}
                          fullWidth
                        />
                      </Box>
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField
                          name="rfq_number"
                          label="RFQ No"
                          value={orderForm.rfq_number}
                          onChange={onChange}
                          fullWidth
                        />
                        <TextField
                          name="po_number"
                          label="PO No"
                          value={orderForm.po_number}
                          onChange={onChange}
                          fullWidth
                        />
                      </Box>
                      <TextField
                        name="commited_delivery_date"
                        label="Committed Delivery Date"
                        type="date"
                        value={orderForm.commited_delivery_date || ""}
                        onChange={onChange}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  )}

                  {activeStep === 1 && (
                    <Box sx={{ mt: 2, display: "grid", gap: 2 }}>
                      <FormControl fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="current_status"
                          value={orderForm.current_status}
                          label="Status"
                          onChange={onChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {STATUS_OPTS.map((o) => (
                            <MenuItem key={o.value} value={o.value}>
                              {o.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel>Priority</InputLabel>
                        <Select
                          name="priority"
                          value={orderForm.priority}
                          label="Priority"
                          onChange={onChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {PRIORITY_OPTS.map((o) => (
                            <MenuItem key={o.value} value={o.value}>
                              {o.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* <FormControl fullWidth>
                        <InputLabel>Assigned To</InputLabel>
                        <Select
                          name="assigned_to"
                          value={orderForm.assigned_to || ""}
                          label="Assigned To"
                          onChange={onChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {users.map((u) => (
                            <MenuItem key={u.id} value={u.id}>
                              {u.full_name || u.username}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl> */}
                    </Box>
                  )}

                  {activeStep === 2 && (
                    <Box sx={{ mt: 2, display: "grid", gap: 2 }}>
                      <TextField
                        name="status_remarks"
                        label="Status Remarks"
                        value={orderForm.status_remarks}
                        onChange={onChange}
                        fullWidth
                        multiline
                      />

                      {editingOrder && (
                        <Card
                          variant="outlined"
                          sx={{ p: 2, background: alpha("#005b82", 0.03) }}
                        >
                          <Typography variant="caption" color="text.secondary">
                            <b>Created by:</b>{" "}
                            {editingOrder.created_by_name || "-"} &nbsp;|&nbsp;
                            <b>Created:</b>{" "}
                            {editingOrder.created_at
                              ? new Date(
                                  editingOrder.created_at
                                ).toLocaleString()
                              : "-"}{" "}
                            &nbsp;|&nbsp; <b>Updated:</b>{" "}
                            {editingOrder.updated_at
                              ? new Date(
                                  editingOrder.updated_at
                                ).toLocaleString()
                              : "-"}
                          </Typography>
                        </Card>
                      )}
                    </Box>
                  )}
                </DialogContent>

                <DialogActions>
                  <Button onClick={closeModal}>Cancel</Button>
                  <Box sx={{ flex: 1 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={() => setActiveStep((s) => s - 1)}
                    variant="outlined"
                  >
                    Back
                  </Button>
                  {activeStep < 2 ? (
                    <Button
                      variant="contained"
                      onClick={() => setActiveStep((s) => s + 1)}
                    >
                      Next
                    </Button>
                  ) : (
                    <Button variant="contained" onClick={onSubmit}>
                      {editingOrder ? "Update Order" : "Create Order"}
                    </Button>
                  )}
                </DialogActions>
              </Dialog>
            )}
          </AnimatePresence>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default OrderTracker;
